import React, {useState} from 'react';
import Dialog from '@mui/material/Dialog';
import PropTypes from 'prop-types';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Button, FormLabel, TextField} from '@mui/material';
import { useTranslation } from 'react-i18next';
import SaveButton from '../Common/SaveButton';

export default function PasswordResetModal(props) {
    const {open, close, loading, handleSubmitReset} = props;
    const { t } = useTranslation();

    const[username, setUsername] = useState('');
    return(
        <Dialog open={open}>
            <DialogTitle>{t('passwordReset.title')}</DialogTitle>
            <DialogContent>
                <FormLabel>{t('passwordReset.help.enterUsername')}</FormLabel>
                <TextField sx={{width: '100%'}} value={username} onChange={(event) => setUsername(event.target.value)} />
            </DialogContent>
            <DialogActions>
                <Button disabled={loading} className={'mobile-modal-button'} variant={'contained'} onClick={close}>{t('common.cancel')}</Button>
                <SaveButton loading={loading} className={'mobile-modal-button'} variant={'contained'} onClick={() => handleSubmitReset(username)}>{t('common.submit')}</SaveButton>
            </DialogActions>
        </Dialog>
    );
}

PasswordResetModal.propTypes = {
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    handleSubmitReset: PropTypes.func.isRequired,
};
